/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from './..\\actor\\defs.defs.js'

const $nsid = 'app.bsky.graph.getMutes'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  mutes: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerates accounts that the requesting account (actor) currently has fully muted. Mutes scoped to specific kinds of content (only reposts, only quote posts) are not included. Responses may contain more items than the requested limit. Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
